import { createBrowserHistory } from 'history';
import { produce } from 'immer';
import isDate from 'lodash/isDate';

export * from './format-phone-number';
export * from './is-localhost';

export const history = createBrowserHistory();

export const STANDARD_DATE_FORMAT = 'yyyy-MM';
export const DATE_FORMAT_WITH_DAY = 'yyyy-MM-dd';

function dateToString(date: Date, dateFormat = STANDARD_DATE_FORMAT) {
  const includeDay = dateFormat === DATE_FORMAT_WITH_DAY;

  let month = (date.getMonth() + 1).toString();
  month = month.length === 1 ? `0${month}` : month;

  let dateString = `${date.getFullYear()}-${month}`;

  if (includeDay) {
    let day = date.getDate().toString();
    day = day.length === 1 ? `0${day}` : day;

    dateString += `-${day}`;
  }

  return dateString;
}

export function swapDateFormat(
  date: string | Date,
  dateFormat = STANDARD_DATE_FORMAT
) {
  if (isDate(date)) {
    return dateToString(date, dateFormat);
  }

  // date format yyyy-MM[-dd]
  const [year, month, day] = date.split('-');

  if (!year || !month) {
    throw new Error('Invalid date string: year and month are required');
  }
  const parsedYear = Number.parseInt(year, 10);
  const parsedMonth = Number.parseInt(month, 10);
  if (Number.isNaN(parsedYear) || Number.isNaN(parsedMonth)) {
    throw new Error('Invalid date string: year or month is not a number');
  }
  const parsedDay = day ? Number.parseInt(day, 10) : undefined;
  if (day && Number.isNaN(parsedDay)) {
    throw new Error('Invalid date string: day is not a number');
  }
  const dateObj = new Date();
  dateObj.setFullYear(
    parsedYear,
    // Months are 0-indexed in JS Date
    parsedMonth - 1,
    parsedDay ?? 1
  );

  return dateToString(dateObj, dateFormat);
}

type FileDownloadResponse = {
  fileBlob: Blob;
  responseContentDisposition: string;
};
export function downloadFile({
  fileBlob,
  responseContentDisposition,
}: FileDownloadResponse) {
  if (!responseContentDisposition) {
    return;
  }

  const filename = responseContentDisposition.split('filename=')[1];
  const filenameInQuotes = filename?.match(/"([^"]+)"/);
  const blobURL = window.URL.createObjectURL(fileBlob);
  const a = document.createElement('a');
  a.href = blobURL;
  let downloadName = '';
  if (filenameInQuotes && filenameInQuotes[1]) {
    downloadName = filenameInQuotes[1];
  } else if (typeof filename === 'string') {
    downloadName = filename;
  }
  a.download = downloadName;
  a.click();
  a.remove();
}

export function write<S>(
  updater: (state: S) => void,
  returnNew = false
): (state: S) => S {
  return (state) =>
    produce(state, (draft) => {
      const r = updater(draft as S);
      if (returnNew) {
        return r;
      }
    });
}
